module.exports = __webpack_public_path__ + "img/P05.21abec80.jpg";